import { render, staticRenderFns } from "./ForgetDebt.vue?vue&type=template&id=65e21677&"
import script from "./ForgetDebt.vue?vue&type=script&lang=js&"
export * from "./ForgetDebt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports